import React from "react";
import { Navigate } from "react-router-dom";

export default function GuestRoute({ children }) {
  const token = localStorage.getItem("authToken");
  return token ? <Navigate to="/" replace /> : children;
}
